import { takeLatest, put, select } from 'redux-saga/effects';
import { message } from 'antd';
import getMetricsData from '@api/metricContainer';
import { autoRequest } from '@api/createRequestStore';
import * as actions from './actions';
import * as types from './types';
import * as selectors from './selectors';

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching() {
  const payloads = yield select(selectors.payloadsSelector);
  if (!payloads || payloads.length <= 1) {
    return;
  }
  try {
    yield autoRequest(getMetricsData, types.SCOPE, payloads);
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchFetching() {
  yield takeLatest([
    actions.fetching().type,
  ], fetching);
}

export default [
  watchInitRequest,
  watchFetching,
];
